import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';
import { BrowserRouter } from 'react-router-dom';
import { initGA } from './utils/analytics';
import Auth0SSOGuard from './components/Auth0SSOGuard';

// Initialize Google Analytics
if (process.env.REACT_APP_GA_TRACKING_ID) {
  initGA(process.env.REACT_APP_GA_TRACKING_ID);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        scope: 'openid profile email offline_access'
      }}
      onRedirectCallback={(appState) => {
        const returnTo = appState?.returnTo || window.location.pathname + window.location.search;
        if (returnTo.startsWith('http://') || returnTo.startsWith('https://')) {
          window.location.href = returnTo;
        } else {
          window.history.replaceState(null, null, returnTo);
        }
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      <BrowserRouter>
        <Auth0SSOGuard>
          <App />
        </Auth0SSOGuard>
      </BrowserRouter>
    </Auth0Provider>
  </React.StrictMode>
);
reportWebVitals();
